export default "__VITE_ASSET__DFPI5HXo__"